import React, {useState, useContext, useEffect, useRef} from 'react';
import {GlobalHeaderPagelet} from '@tkww/orion-web-global-pagelets';
import {MemberAuthModal} from '@tkww/orion-web-theknot-auth';
import MemberContext from '../../../contexts/MemberContext';
import useConversations from '../../../queries/useConversations';
import {SIGN_UP, LOG_IN} from '../../../constants/union';

const HeaderNavWithMembershipModal = headerProps => {
  const modal = useRef(null);
  const [openModal, setOpenModal] = useState('');
  const {isLoggedIn, member, signUp, logIn, logOut} = useContext(MemberContext);
  const {data: unreadMessagesCount = 0} = useConversations({
    memberId: member?.id,
  });

  const openSignUpModal = () => setOpenModal(SIGN_UP);
  const openLogInModal = () => setOpenModal(LOG_IN);
  const closeModal = () => setOpenModal('');

  const headerForwardProps = {
    ...headerProps,
    couplePhotoUrl: member?.couple_photo_url,
    loggedIn: Boolean(isLoggedIn && member?.id),
    onClickLogIn: openLogInModal,
    onClickSignUp: openSignUpModal,
    onClickLogOut: logOut,
    unreadMessagesCount,
    activeProduct: 'registry',
  };

  if (member) {
    headerForwardProps.membership = {data: {member}};
  }

  useEffect(() => {
    const escFunction = event => {
      if (event.keyCode === 27) {
        closeModal();
      }
    };

    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, []);

  const handleLogIn = async ({valid, data}) => {
    if (!valid) return;

    try {
      await logIn({
        email: data.email,
        password: data.password,
      });

      closeModal();
    } catch (e) {
      let message = 'Oops, something went wrong.';

      if (e.userFacingError) {
        message = e.userFacingError;
      }

      modal.current.showError(message);
    }
  };

  const handleSignUp = async ({valid, data}) => {
    if (!valid) return;

    try {
      await signUp({
        email: data.email,
        password: data.password,
        brand: 'theknot',
        action: 'Click Sign Up',
        application: 'transactional-registry',
      });

      closeModal();
    } catch (e) {
      let message = 'Oops, something went wrong.';

      if (e.userFacingError) {
        message = e.userFacingError;
      }

      modal.current.showError(message);
    }
  };

  return (
    <>
      <GlobalHeaderPagelet forwardProps={headerForwardProps} />
      <MemberAuthModal
        ref={modal}
        metadata={{
          applicationName: 'transactional-registry',
          userAction: 'header',
        }}
        openModal={openModal || null}
        onClickLogIn={openLogInModal}
        onClickSignUp={openSignUpModal}
        onClose={closeModal}
        onSignUp={handleSignUp}
        onLogIn={handleLogIn}
        inProgress={false}
      />
    </>
  );
};

export default HeaderNavWithMembershipModal;
